export const GREEN = "#24AE7C";
export const GREEN_FADE_BG = "#24AE7C0D";
export const GREEN_BORDER = "#24AE7C33";
export const GREEN_TINT = "#24AE7C14";
export const TEXT_DARK = "#0b3b2d";
